module.exports = __webpack_public_path__ + "img/header-bg-1.97a58a75.png";